import { Theme } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme: Theme) => ({
  title: {
    fontWeight: 700,
    fontSize: 'clamp(16px, 1.30vw, 27px)',
    color: theme.palette.primary.main,
    marginBottom: theme.spacing(2),
    gap: '8px',
    display: 'flex',
    alignItems: 'center',
  },
  indicatorsTotalsContainer: {
    display: 'flex',
    gap: 'clamp(40px, 5.21vw, 100px)',
  },
  totalCard: {
    background: '#fff',
    borderRadius: 16,
    padding: theme.spacing(4),
    border: '1px solid #e5e8f0',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    gap: theme.spacing(1),
  },
  totalLabel: {
    fontSize: 'clamp(10px, 1.30vw, 27px)',
    fontWeight: 700,
    color: '#5BC2D5',
    marginBottom: theme.spacing(1),
  },
  totalValue: {
    fontSize: 'clamp(28px, 3.65vw, 75px)',
    fontWeight: 700,
    color: theme.palette.primary.gray,
    lineHeight: 1.1,
  },
  totalDescription: {
    fontSize: 'clamp(8px, 1.04vw, 21px)',
    fontWeight: 400,
    color: theme.palette.primary.gray,
  },
  locationGrid: {
    marginTop: 'clamp(12px, 1.56vw, 30px)',
    '& .MuiGrid-item': {
      paddingTop: 0,
    },
  },
  locationCard: {
    borderRadius: '10px',
    padding: 'clamp(8px, 1.04vw, 20px)',
    backgroundColor: '#fff',
    display: 'flex',
    height: '100%',
    flexDirection: 'column',
    boxShadow: '0px 0px 4px 0px #00000040',
    '& > .MuiBox-root:first-of-type': {
      marginBottom: '5px',
    },
  },
  locationRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  locationAmount: {
    fontSize: 'clamp(6px, 0.83vw, 17px)',
    fontWeight: 700,
    color: theme.palette.primary.gray,
  },
  legend: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
  },
  legendLabel: {
    fontSize: 'clamp(6px, 0.83vw, 17px)',
    fontWeight: 400,
    color: theme.palette.primary.gray,
  },
  legendDot: {
    width: 8,
    height: 8,
    borderRadius: '50%',
    display: 'inline-block',
  },
  legendDotPaid: {
    backgroundColor: '#c1e8ed',
  },
  legendDotTotal: {
    backgroundColor: theme.palette.primary.gray,
  },
  textfieldContainer: {
    minWidth: '250px',
    marginRight: '10px',
  },
  divider: {
    margin: 'clamp(12px, 1.56vw, 30px) 0px',
  },
}));

export default useStyles;
